import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  warningIcon: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageFrameContent: {
    margin: 0,
    position: 'relative',
  },
  downloadBtn: {
    position: 'absolute',
    border: 'none',
    right: 8,
    top: 8,
  },
  checkboxPos: {
    position: 'absolute',
    right: '6px',
    top: '4px',
  },
  imageLoading: {
    width: '100%',
    height: '100%',
    aspectRatio: 1,
    backgroundColor: 'var(--backgrounds-tint-2)',
    borderRadius: 'var(--radius-16)',
    // padding: 'var(--spacing-10)'
  },
  header: {
    background: 'var(--backgrounds-tint-1)',
    borderBottom: '1px solid var(--backgrounds-tint-2)',
  },
  footer: {
    borderTop: '1px solid var(--backgrounds-tint-2)',
  },
  mainContent: {
    width: '100%',
    position: 'relative',
  },
  backBtn: {
    flexShrink: 0,
  },
  closeIcon: {
    cursor: 'pointer',
  },
  tooltip: {
    marginLeft: 'auto',
    cursor: 'pointer',
  },
});

export default useStyles;
